module.exports = require("babel-core");


//////////////////
// WEBPACK FOOTER
// external "babel-core"
// module id = 0
// module chunks = 0